import { IFSC_REGEX } from '../../../../utils/constants/regex';
import * as yup from 'yup';

export const bankSchemaWithNoValidation = yup.object({
  bankAccountNumber: yup.string(),
  bankIFSC: yup.string(),
  accountHolderName: yup.string(),
  razorpayId: yup.string(),
  uploadedCancelChequeFile: yup.object({
    shortUrl: yup.string(),
    url: yup.string(),
  }),
});

export const bankSchemaWithValidations = yup.object({
  bankAccountNumber: yup
    .string()
    .required('Bank account number is required')
    .max(
      255,
      'Bank account should be maximum 255 characters'
    ),
  bankIFSC: yup
    .string()
    .required('IFSC code is required')
    .matches(IFSC_REGEX, 'IFSC code should be valid')
    .length(11, 'IFSC code should be 11 characters'),
  accountHolderName: yup
    .string()
    .required('Account holder name is required')
    .max(
      255,
      'Account holder should be maximum 255 characters'
    ),
  razorpayId: yup
    .string()
    .required('Razorpay account Id is required')
    .max(
      255,
      'Razorpay account Id should be maximum 255 characters'
    ),
  uploadedCancelChequeFile: yup.object({
    shortUrl: yup
      .string()
      .required('Please upload Canceled Cheque'),
    url: yup
      .string()
      .required('Please upload Canceled Cheque'),
  }),
});

export const bankSchemaWithCheckbox = yup.object({
  selectBankCheckboxOption: yup.boolean().default(false),
  bankDetails: bankSchemaWithNoValidation.when(
    'selectBankCheckboxOption',
    ([selectBankCheckboxOption], schema) => {
      return selectBankCheckboxOption
        ? schema
        : schema.concat(bankSchemaWithValidations);
    }
  ),
});
